<template>
  <div class="basic-layout">
    <Header :current-step="currentStep" :status="orderStatus" :number="orderNumber" />
    <slot :car="car" :order="order" :status="orderStatus" :number="orderNumber" />
    <Footer :car-id="carId" />
  </div>
</template>

<script>
import Header from './Header';
import Footer from './Footer';
import { getCarDetails, getOrderInfo, getRedirectUrl } from '@/api/checkout';

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      car: null,
      order: null,
      status: '',
    };
  },
  computed: {
    currentStep() {
      return this.$route.name;
    },
    carId() {
      return this.$route.query.carId || '';
    },
    orderStatus() {
      if (this.status === 'rejected' || this.status === 'cancelled') {
        return 'storniert';
      }
      if (this.status === 'approved' || this.status === 'added') {
        return 'wird geprüft';
      }
      return 'bestätigt';
    },
    orderNumber() {
      return (this.order && this.order.number) || '';
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      if (this.currentStep === '1') {
        getCarDetails(this.carId)
          .then(r => {
            this.car = r;
          })
          .catch(() => {
            this.$router.push({ name: 'error' });
          });
      } else if (this.currentStep !== 'error') {
        const { token } = this.$route.query;
        getOrderInfo(token)
          .then(r => {
            this.order = r;
            this.car = r.car_info;
            this.status = r.status;
            if (this.currentStep === 'bankAgreement') {
              if (this.status === 'added') {
                // Temporary commented OUT, switch to manual redirecting, by button
                
                // getRedirectUrl(token).then(res => {
                //   window.location.replace(res.redirect_url);
                // });
              } else if (this.status === ('incompleted' || 'rejected')) {
                this.$router.push({ name: 'error' });
              }
            } else {
              switch (this.status) {
                case 'approved':
                  if (this.$route.name !== '5') {
                    this.$router.replace({ name: '5', query: this.$route.query });
                  }
                  break;
                case 'draft':
                  if (this.$route.name !== '1') {
                    sessionStorage.setItem('order', JSON.stringify(this.order));
                    sessionStorage.setItem('currentOrderStep', '1');
                    this.$router.replace({ name: '1', query: { carId: this.car.id, step: '1' } });
                  }
                  break;
                case 'initiated':
                  if (this.$route.name !== '1') {
                    sessionStorage.setItem('order', JSON.stringify(this.order));
                    sessionStorage.setItem('currentOrderStep', '7');
                    this.$router.replace({ name: '1', query: { carId: this.car.id, step: '7' } });
                  }
                  break;
                case 'added':
                  if (this.$route.name !== '1') {
                    sessionStorage.setItem('order', JSON.stringify(this.order));
                    sessionStorage.setItem('currentOrderStep', '7');
                    this.$router.replace({ name: '1', query: { carId: this.car.id, step: '7' } });
                  }
                  break;
                case 'confirmed':
                  if (this.$route.name !== '2') {
                    this.$router.replace({ name: '2', query: this.$route.query });
                  }
                  break;
                case 'delivery_agreed':
                  if (this.$route.name !== '3') {
                    this.$router.replace({ name: '3', query: this.$route.query });
                  }
                  break;
                case 'closed':
                  if (this.$route.name !== '3') {
                    this.$router.replace({ name: '3', query: this.$route.query });
                  }
                  break;
                case 'rejected':
                  if (this.$route.name !== '4') {
                    this.$router.replace({ name: '4', query: this.$route.query });
                  }
                  break;
                case 'cancelled':
                  if (this.$route.name !== '4') {
                    this.$router.replace({ name: '4', query: this.$route.query });
                  }
                  break;
                default:
                  break;
              }
            }
          })
          .catch(() => {
            this.$router.push({ name: 'error' });
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.basic-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
}
</style>
